/*
Builds a good map with pins
NEEDS TO HAVE THE GOOGLE SCRIPTS ADDED TO HELP DROP PINS ETC
	<div class="google-map" data-zoom="12">
		<div class="marker" data-lat="<?php echo $iLat;?>" data-lng="<?php echo $iLong;?>" data-marker="<?php echo THEME_DIRECTORY_IMGS;?>icons/map-pin.svg"></div>
	</div>

*/

function fnGoogleMap( i, oSection ) {
	var oMap = $(oSection);

	// Global Vars
	var aMarkers = new Array(),
		oMarkers = oMap.find( '.marker' ),
		iCenterLat = parseInt( oMap.attr( 'data-center-lat' ), 0 ),
		iCenterLng = parseInt( oMap.attr( 'data-center-lng' ), 0 ),
		iZoom 	= parseInt( oMap.attr( 'data-zoom' ), 0 ),
		iMinZoom = ( $( document ).width() >= 480 ) ? parseInt(oMap.attr( 'data-min-zoom' ), 0) : 1,
		sMapLandColour = "#D8E1E9";


		// vars
		var args = {
			backgroundColor			: "#FFFFFF",
			zoomControl				: true,
			scrollwheel				: true,
			disableDoubleClickZoom	: false,
			draggable				: true,
			disableDefaultUI		: false,
			scrollwheel				: false,
			zoom					: iZoom,
			minZoom 				: iMinZoom,
			center					: new google.maps.LatLng(iCenterLat,iCenterLng),
			mapTypeId				: google.maps.MapTypeId.ROADMAP,
			styles					: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
		};

		// create map
		var oGoogleMap = new google.maps.Map( oMap[0], args);

		// add a markers reference
		oGoogleMap.markers = [];

		// add markers
		oMarkers.each(function(){
	    	add_marker( $(this));
		});

		// center map
		center_map( oGoogleMap,iZoom );
		//	Open the first pin by default
		//	oHqMarker.infowindow.open(oGoogleMap, aMarkers[0]);


	/*
	*	Plot pin markers and any html that will show when clicked
	 */
	function add_marker( oMarker) {

		var latlng, contentString, infowindow,oGoogleMarker;
		// var
		latlng = new google.maps.LatLng( oMarker.attr('data-lat'), oMarker.attr('data-lng') );

		//	Bind Html to popup
		contentString = oMarker.html();
		contentString = contentString.concat('</div>');

		infowindow = new google.maps.InfoWindow({
			content: contentString
		});


		//	http://aaronmiler.com/blog/google-maps-v3-custom-html-map-marker/
		//	https://levelup.gitconnected.com/how-to-create-custom-html-markers-on-google-maps-9ff21be90e4b
		var sMarker = oMarker.attr('data-marker');
		if($(document).width() <= 1024){
			sMarker = oMarker.attr( 'data-marker-small' );
		}

		if (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
            sMarker = oMarker.attr('data-marker-fallback');
        }


		oGoogleMarker = new google.maps.Marker({
			position	: latlng,
			//animation: google.maps.Animation.DROP,
			map			: oGoogleMap,
			visible		: true,
			title		: oMarker.attr( 'data-marker-type' ),
			icon		: sMarker,
			/*
			icon: {
			  path: google.maps.SymbolPath.CIRCLE,
			  scale: 5, //tamaño
			  strokeColor: '#FFFFFF', //color del borde
			  strokeWeight: 2, //grosor del borde
			  fillColor: '#11B3C2', //color de relleno
			  fillOpacity:1// opacidad del relleno
			},
*/
      		infowindow 	: infowindow
		});


		//	Add this marker to a list of them for closing
		aMarkers.push(oGoogleMarker);


		google.maps.event.addListener(oGoogleMarker, 'click', function() {
			//	Close all other windows
			aMarkers.forEach(function(marker) {
				marker.infowindow.close(oGoogleMap, marker);
			});



			//	Open the info window
			this.infowindow.open(oGoogleMap, this);

		    var iw_container = $(".gm-style-iw").parent();
		    iw_container.stop().hide();
		    iw_container.fadeIn(1000);

			//	Pan to the info windows(Disabled for this project)
			//oGoogleMap.panTo(this.getPosition());
	    });




		// Add Map pin to Google map!
		oGoogleMap.markers.push( oGoogleMarker );

		//	Return it if neded
		return oGoogleMarker;
	}






	/*
	*  This function will center the map, showing all markers attached to this map
	*/
	function center_map( map,iZoom ) {
		var iZoom = iZoom;

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ){
			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
			bounds.extend( latlng );
		});
/*
		// only 1 marker?
		if( map.markers.length == 1 ){
			// set center of map
		    //map.setCenter( bounds.getCenter() );
		    map.setZoom( iZoom );
		}else{
*/
		//	We dont have a zoom value set
		if ( isNaN( parseFloat( iZoom ) ) ) {
			// fit to bounds
			map.fitBounds( bounds );
		}
/*		}*/

	}




}
